<div class="title">آیا گیاه‌خوار هستید؟</div>
<div class="veg-holder">
  <div class="container">
    <div class="img-holder" (click)="vegTypeSelect(1)">
      <img src="assets/generate/Vegeterian.png" />
    </div>
    <button
      class="submit-active"
      (click)="vegTypeSelect(1)"
      *ngIf="vegType === 1"
    >
      <div class="title-active">بله</div>
    </button>
    <div
      class="submit-disable"
      (click)="vegTypeSelect(1)"
      *ngIf="vegType === undefined || vegType === 0"
    >
      <div class="title-disable">بله</div>
    </div>
  </div>
  <div class="container">
    <div class="img-holder">
      <img src="assets/generate/NotVegeterian.png" />
    </div>
    <button
      class="submit-active"
      (click)="vegTypeSelect(0)"
      *ngIf="vegType === 0"
    >
      <div class="title-active">خیر</div>
    </button>
    <div
      class="submit-disable"
      (click)="vegTypeSelect(0)"
      *ngIf="vegType === undefined || vegType === 1"
    >
      <div class="title-disable">خیر</div>
    </div>
  </div>
</div>
